import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { UIIcon } from '../icon';

@Component({
  selector: 'ui-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NzDropDownModule, UIIcon],
})
export class UIDropdownMenu<T> {
  @Input() menus: T[] = [];
  @Input() textField!: keyof T;
  @Input() iconField: keyof T | null = null;
  @Input() selectedIndex?: number;

  @Output() menuSelected = new EventEmitter<T>();

  onMenuSelected(menu: T): void {
    this.menuSelected.emit(menu);
  }

  getIconName(item: T): string | undefined {
    if (!this.iconField) return undefined;
    const value = item[this.iconField];
    return typeof value === 'string' ? value : undefined;
  }
}
